import React, { useContext, useEffect, useState } from 'react';

import Alerta from "../modal/Alerta";
import AuthContext from '../../context/authentication/authContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import centroenlace from '../../img/centroenlace.jpg';
import EvaluacionRealizada from './EvaluacionRealizada';

function Evaluacion() {

    useEffect(() => {
        consultarEvaluacion(evaluation);
        // eslint-disable-next-line
    }, [])

    const authToken = useContext(AuthContext);
    const { user } = authToken;

    const evaluationContext = useContext(EvaluationContext);
    const { formulario, matchedId, evaluacion, consultarEvaluacion, guardarEvaluacion } = evaluationContext;

    const [ showAlerta, setShowAlerta] = useState(false);
    const [ msg ] = useState("");

    const [ evaluation, setEvaluation ] = useState({
        form: formulario._id,
        evaluated: matchedId,
        meeting_date: '',
        duration: '',
        scores: [],
        comments: [],
        expectatives: '',
        final_question: ''
    });

    const evaluated = sessionStorage.getItem('evaluated');

    //console.log(formulario);
    //console.log(evaluation);

    if (evaluacion.length === formulario.number) return <EvaluacionRealizada />
    if (evaluacion.form === formulario._id) return <EvaluacionRealizada />

    // eslint-disable-next-line
    const { meeting_date, duration, scores, comments, expectatives, final_question } = evaluation;

    const onChange = e => {
        setEvaluation({
            ...evaluation,
            [e.target.name] : e.target.value
        });
    }

    const onChangeComentarios = e => {
        let temp = e.target.name.split('-')
        evaluation.comments[temp[1]] = e.target.value;
    }

    const onClickPuntuacion = e => {
        let temp = e.target.name.split('-')
        evaluation.scores[temp[1]] = parseInt(e.target.value, 10);
    }

    const onSubmit = e => {
        e.preventDefault();
        guardarEvaluacion(evaluation);
    }

    function Pregunta(props) {
        const { n, question } = props;
        return (
            <>
                <div className="form-row">
                    <div className="form-group col-md-1"></div>
                    <div className="form-group col-md-10">
                        <span dangerouslySetInnerHTML={{__html: question}}></span>
                        <br/>
                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group" onChange={onClickPuntuacion}>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={1} required="required" defaultChecked={scores[n] === 1} /> 1 Muy insatisfecho</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={2} required="required" defaultChecked={scores[n] === 2} /> 2</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={3} required="required" defaultChecked={scores[n] === 3} /> 3</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={4} required="required" defaultChecked={scores[n] === 4} /> 4</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={5} required="required" defaultChecked={scores[n] === 5} /> 5</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={6} required="required" defaultChecked={scores[n] === 6} /> 6</label>
                            <label className="btn btn-outline-primary" ><input type="radio" className="btn-check" name={`seccionB-${n}`} value={7} required="required" defaultChecked={scores[n] === 7} /> 7 Muy satisfecho</label>
                        </div>
                        <textarea className="form-control" name={`comments-${n}`} id={`seccionB[${n}].comentario`} placeholder="Comentarios" value={comments[n]} onChange={onChangeComentarios} ></textarea>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className="container">
                { showAlerta && <Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={msg} /> }
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-small">
                            <div className="card-header border-bottom">
                                <h4 className="m-0">{formulario.title}</h4>
                            </div>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item p-3">
                                    <div className="row">
                                        <div>
                                            <img src={centroenlace} className="logo-centro-enlace" alt="logo" />
                                        </div>
                                    </div>
                                    <div className="row">                                        
                                        <div className="col">
                                        { user.profile === 'Teacher' ? (
                                            <div>
                                                <h2>Estimado Mentor,</h2>
                                                <p>Le agradecemos responder esta breve encuesta luego de haber tenido la primera reunión con su alumno(a) asignado(s).<br/>No le tomará más de 3 minutos.<br/>Muchas gracias.<br/><br/><i>Equipo Centro de Enlace UC</i></p><br/>
                                                <h3>Alumno evaluado: {evaluated}</h3>
                                            </div>
                                        ) : (
                                            <div>
                                                <h2>Estimado(a) Alumno(a),</h2>
                                                <p>Te agradecemos responder esta breve encuesta luego de haber concluido la primera reunión con tu mentor(a).<br/>No te tomará más de 3 minutos.<br/>Muchas gracias.<br/><br/><i>Equipo Centro de Enlace UC</i></p><br/>
                                                <h3>Mentor evaluado: {evaluated}</h3>
                                            </div>
                                        )}
                                        <form onSubmit={onSubmit}>
                                            <h5>A. Aspectos Generales</h5>
                                            <div className="form-row">
                                                <div className="form-group col-md-1"></div>
                                                <div className="form-group col-md-2">
                                                    <label htmlFor="meeting_date">Fecha</label>
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <input 
                                                        type="date" 
                                                        name="meeting_date" 
                                                        id="meeting_date" 
                                                        className="form-control" 
                                                        value={meeting_date} 
                                                        onChange={onChange}
                                                        required="required" />
                                                </div>
                                                <div className="form-group col-md-2">
                                                    <label htmlFor="duration">Duración de la reunión</label>                                                    
                                                </div>
                                                <div className="form-group col-md-3">
                                                    <select
                                                        name="duration" 
                                                        id="duration"
                                                        className="form-control"
                                                        title="Duración de la reunión"
                                                        onChange={onChange}
                                                        required >
                                                            <option value="" disabled="disabled">Duración</option>
                                                            <option value="15 minutos" >15 minutos</option>
                                                            <option value="30 minutos" >30 minutos</option>
                                                            <option value="45 minutos" >45 minutos</option>
                                                            <option value="60 minutos" >60 minutos</option>
                                                            <option value="90 minutos" >90 minutos</option>
                                                            <option value="120 minutos" >120 minutos</option>
                                                    </select>
                                                </div>
                                            </div>
                                            
                                            <h5>B. Percepción General</h5>
                                            { user.profile === 'Teacher' ? (
                                                <div>
                                                    <p><b>Califique de 1 a 7</b> los siguientes aspectos según su grado de satisfacción, donde 1 es muy insatisfecho y 7 es muy satisfecho. Puede realizar un breve comentario para justificar su respuesta.</p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p><b>Califica de 1 a 7</b> los siguientes aspectos según tu grado de satisfacción, donde 1 es muy insatisfecho y 7 es muy satisfecho. Puedes realizar un breve comentario para justificar tu respuesta.</p>
                                                </div>
                                            )}
                                            
                                            { formulario.questions.map((item, index) => {
                                                    return(
                                                        <Pregunta n={index} key={index} question={item.q}/>
                                                    );
                                                })
                                            }
                                            
                                            <h5>C. Expectativas</h5>
                                            <div className="form-row">
                                                <div className="form-group col-md-1"></div>
                                                <div className="form-group col-md-10">
                                                    <span dangerouslySetInnerHTML={{__html: formulario.expectatives }}></span>
                                                    <textarea 
                                                        className="form-control" 
                                                        name="expectatives" 
                                                        id="expectatives" 
                                                        placeholder="Expectativas" 
                                                        value={expectatives} 
                                                        onChange={onChange}
                                                        required="required" ></textarea>
                                                </div>
                                            </div>

                                            { formulario.final_question && (
                                                <>
                                                    <h5>D. Pregunta Final</h5>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-1"></div>
                                                        <div className="form-group col-md-10">
                                                            {formulario.final_question}
                                                            <textarea 
                                                                className="form-control" 
                                                                name="final_question" 
                                                                id="final_question" 
                                                                placeholder="Respuesta Final" 
                                                                value={final_question} 
                                                                onChange={onChange}
                                                                required="required" ></textarea>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            
                                            <button type="submit" className="btn btn-accent">Guardar Datos</button>
                                        </form>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Evaluacion